import React, { useState, useRef, useEffect, Fragment } from "react";
import toogleEdit from "../../assets/images/model/toogleEdit.svg";
import toogleNavegate from "../../assets/images/model/toogleNavegate.svg";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { blanksShow } from "../../Store/api/activities";
import { useDispatch } from "react-redux";
const stringToArray = (str) => str.split(" "); // Split by space
const removeHtmlTags = (text) => text.replace(/<\/?[^>]+>/gi, ""); // Remove HTML tags

const FillBlanksOption = ({
  setIsEditing,
  isEditing,
  question,
  editing,
  activity,
  mode,
  isMore,
  setQuestions,
  index,
  setIsTotalBlanks,
}) => {
  const [error, setError] = useState("");
  const quillRef = useRef(null);
  const grey = "var(--Grey-900, #2E2E2D)";
  const highlightColor = "var(--Purple-200, #eeeaf6)";
  const [isToggled, setIsToggled] = useState(false);
  const [isShowBlanks, setIsShowBlanks] = useState(() => {
    const storedValue = localStorage.getItem(
      `isStudentBlanksShow_${question._id}`
    );
    return storedValue === "true"; // Convert the stored string to a boolean
  });
  const [isShowBlanksState, setIsShowBlanksState] = useState({});
  const dispatch = useDispatch();
  const modules = {
    toolbar: {
      container: [["bold", "italic", "underline", "clean"]],
    },
  };
 
  const formats = ["bold", "italic", "underline", "color"];

  const handleChange = (HTML) => {
    setQuestions((old) => ({
      ...old,
      questions: old.questions.map((q, i) =>
        i === index
          ? {
              ...q,
              sentence: HTML,
              bankQuestion: !removeHtmlTags(HTML)
                ? []
                : removeHtmlTags(HTML)
                    .toLowerCase()
                    .replace(/\./g, "")
                    .split(" "),
            }
          : q
      ),
    }));
  };

  const handleSave = () => {
    if (question.blanksBank.length === 0) {
      setError(
        "At least 1 blank must be selected in order to save and continue."
      );
    } else {
      setError(""); // Clear error message
      setIsEditing(false);
      setIsTotalBlanks(question.blanksBank.length); // Save the entire blanksBank
    }
  };

  const alternativeBlanks = (questionId, showBlanks) => {
    if (!questionId || !question?.activity) {
      console.error("Question data is incomplete:", question);
      return;
    }

    const payload = {
      activity: question.activity, // activity ID
      question: questionId, // question ID
      isStudentBlanksShow: showBlanks, // Pass true or false based on checkbox state
    };

    // Log the payload to ensure it contains the correct data
    dispatch(
      blanksShow({
        body: payload,
        onSuccess: (res) => {
          localStorage.setItem(
            `isStudentBlanksShow_${questionId}`,
            res.data.data.isStudentBlanksShow
          );
        },
        onError: (error) => {},
      })
    );
  };

  const handleCheckboxChange = (e, questionId) => {
    setQuestions((old) => ({
      ...old,
      questions: old.questions.map((q, i) =>
        i === index ? { ...q, isStudentBlanksShow: e.target.checked } : { ...q }
      ),
    }));
    // const newIsShowBlanks = !isShowBlanksState[questionId];
    // setIsShowBlanksState({
    //   ...isShowBlanksState,
    //   [questionId]: newIsShowBlanks,
    // });

    // localStorage.setItem(`isStudentBlanksShow_${questionId}`, newIsShowBlanks); // Update localStorage
    alternativeBlanks(questionId, e.target.checked);
  };

  const handleToggle = () => {
    const quill = quillRef.current.getEditor();
    const range = quill.getSelection();

    if (range && range.length > 0) {
      const text = quill.getText(range.index, range.length).trim();
      // Ensure that bankQuestion and blanksBank are initialized as arrays
      if (!Array.isArray(question.bankQuestion)) {
        question.bankQuestion = [];
      }
      if (!Array.isArray(question.blanksBank)) {
        question.blanksBank = [];
      }
        const normalizedText = text.replace(/[.,'"!;:\\\/?]/g, '');
      

      if (text && !question.bankQuestion?.some((e)=>e.replace(/[.,'"!;:\\\/?]/g, '')===text) &&  !question.bankQuestion?.includes(text)) {
        setError(
          "Please select an entire word without spaces and without dots!"
        );
        return;
      }

      // Clear error if no error is found
      setError("");

      const currentFormats = quill.getFormat(range.index, range.length);
      const currentColor = currentFormats.color;
      const newColor = currentColor === grey ? null : grey;

      // Apply the style only if there is no error
      quill.formatText(range.index, range.length, {
        color: newColor,
        background: highlightColor,
        borderRadius: "3px",
      });

      // Update the questions state
      setQuestions((old) => ({
        ...old,
        questions: old.questions.map((q, i) =>
          i === index
            ? {
                ...q,
                blanksBank: q.blanksBank
                  .filter((e) => !e.answers.includes(text))
                  .concat(
                    newColor === grey &&
                      !q.blanksBank.find((e) => e.answers.includes(text))
                      ? {
                          indexNo: q.bankQuestion.findIndex((e) => e.replace(/[.,'"!;:\\\/?]/g, '') === text || e===text),
                          answers: [text],
                        }
                      : []
                  ),
              }
            : q
        ),
      }));

      // Set selection and toggling effect
      quill.setSelection(range.index + range.length, 0);
      setIsToggled(true);

      setTimeout(() => {
        setIsToggled(false);
      }, 800);
    }
  };

  const handleAlternateAnswerChange = (indexNo, value) => {
    setQuestions((old) => ({
      ...old,
      questions: old.questions.map((q, i) =>
        i === index
          ? {
              ...q,
              blanksBank: q.blanksBank.map((item) =>
                item.indexNo === indexNo
                  ? {
                      ...item,
                      answers: value
                        .split(",")
                        .map((ans) => ans.trim().toLowerCase()),
                    }
                  : item
              ),
            }
          : q
      ),
    }));
  };

  return (
    <Fragment>
      {isMore && (
        <div
          className={` ${
            isEditing ? `fill_in_the_blanks` : ` bold-border highlight`
          }`}
        >
          <div className={`mr-tp-bt ${isEditing ? "create-view" : ""}`}>
            <ReactQuill
              ref={quillRef}
              theme="snow"
              value={question.sentence} // Use local state value for the editor
              onChange={handleChange} // Handle changes
              modules={modules}
              formats={formats}
              readOnly={!isEditing}
              className={`class-value  ${
                isToggled && "hide-toolbar fill_border"
              } ${isEditing ? "toolbar" : "toolbar_none"}`}
              placeholder="Start typing. Add line breaks for paragraphs or numbers to create a list. Click the toggle to add blanks."
            />

            {error && <div className="error_fill_in_blanks">{error}</div>}

            <div className="alternate_blank" style={{ margin: "8px 0px" }}>
              {isEditing ? "Add alternate answers to the bank" : "Word bank"}
            </div>

            <div className={isEditing ? "" : "blanks-container"}>
              {question.blanksBank.map((item) => (
                <div
                  key={item.indexNo}
                  style={{
                    background: isEditing ? "" : "none",
                    marginBottom: "10px",
                  }}
                  className={`parent_input_with_fill ${
                    isEditing ? "mcqs_border fill-blanks-option" : "word-bank"
                  }`}
                >
                  <div className="parent_input">
                    <textarea
                      className={`orderlist-input alter_words ${
                        !isEditing && "font-12"
                      }`}
                      style={{ paddingTop: "6px", paddingBottom: "5px" }}
                      rows={1}
                      onChange={(e) =>
                        handleAlternateAnswerChange(
                          item.indexNo,
                          e.target.value
                        )
                      }
                      value={item.answers.join(", ")}
                      readOnly={!isEditing}
                    />
                  </div>
                </div>
              ))}
            </div>

            {isEditing ? (
              <div className="option-adder-wrapper mrt-12">
                <div className="Multiplechoice_wrap add_text_save">
                  <div className="parent_radio_button">
                    <div className="radio_button_check">
                      <div
                        className={`white_circle ${
                          isToggled && "toggled_switch"
                        }`}
                        onClick={handleToggle}
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={isToggled ? toogleNavegate : toogleEdit}
                          alt="Toggle Button"
                        />
                      </div>
                    </div>
                    <div className="write_statment">
                      {isToggled
                        ? "Select or deselect blanks"
                        : "Write a statement"}
                    </div>
                  </div>
                  <div style={{ cursor: "pointer" }} onClick={handleSave}>
                    Save --{">"}
                  </div>
                </div>
              </div>
            ) : (
              <Fragment>
                {mode !== "assign" && (
                  <div
                    key={question._id}
                    className="share iagree_radio blanks-opt"
                    style={{ marginTop: "0px", opacity: !editing ? 0.5 : 1 }}
                  >
                    <input
                      type="checkbox"
                      id={`share-activity-${question._id}`}
                      // checked={isShowBlanksState[question._id] || false} // Use state for this specific question
                      disabled={!editing}
                      checked={question.isStudentBlanksShow}
                      onChange={(e) => handleCheckboxChange(e, question._id)} // Pass question ID to handler
                    />
                    <label htmlFor={`share-activity-${question._id}`}>
                      <div>Show word bank to students</div>
                    </label>
                  </div>
                )}
              </Fragment>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default FillBlanksOption;
